"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Bookmark16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "bookmark-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M12,2.01264114 L4,2.00252951 L4,12.2756412 L7.99512774,9.99884511 L12,12.2780149 L12,2.01264114 Z M14,0.0151674514 L14,15.201499 C14,15.3671844 13.8656854,15.501499 13.7,15.501499 C13.6479707,15.501499 13.5968358,15.4879674 13.5516164,15.4622331 L7.99581765,12.3004322 L2.4485399,15.4617881 C2.30458956,15.5438244 2.12139117,15.4936331 2.03935484,15.3496828 C2.01356322,15.3044259 2,15.2532332 2,15.2011429 L2,0 L14,0.0151674514 Z", id: "Path-12", fill: "#000000", fillRule: "nonzero" })));
}
function Bookmark16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Bookmark16Svg, Object.assign({}, svgProps)));
}
exports.default = Bookmark16;
//# sourceMappingURL=Bookmark16.js.map